import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: '登录',
            component: () => import('@/views/login/login.vue'),
            hidden: true,
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/login/login.vue'),
            hidden: true,
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/home/home'),
            hidden: true,
            children: [
				{ path: '/entry/:id', component: () => import('@/views/layout/entry'), name: '', hidden: true, meta: { keepAlive: false } },
                
                { path: '/sp-list', component: () => import('@/views/servicer/list.vue'), name: '服务商列表', hidden: true },

                { path: '/platform-list', component: () => import('@/views/platform/list.vue'), name: '平台列表', hidden: true },

                { path: '/account-list', component: () => import('@/views/account/list.vue'), name: '账户列表', hidden: true },

                { path: '/domain-list', component: () => import('@/views/domains/list.vue'), name: '域名列表', hidden: true },
				
                { path: '/download', component: () => import('@/views/download/list.vue'), name: '下载管理', hidden: true },    

				{ path: '/op-logs', component: () => import('@/views/logs/sysLogList.vue'), name: '业务操作日志', hidden: true },
				
                { path: '/role', component: () => import('@/views/admingroup/list.vue'), name: '角色管理', hidden: true },
                { path: '/admin-list', component: () => import('@/views/adminuser/list.vue'), name: '管理员列表', hidden: true },
                { path: '/update-pwd', component: () => import('@/views/adminuser/password.vue'), name: '修改密码', hidden: true },
                
                { path: '/menu-list', component: () => import('@/views/adminmenu/list.vue'), name: '后台菜单管理', hidden: true },
                { path: '/config', component: () => import('@/views/config/list.vue'), name: '系统配置', hidden: true }
            ],
    
        },
        {
            path: '*',
            redirect: '/home',
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js